import BaseNextImage, { BaseNextImageProps } from './BaseNextImage';

interface FixedNextImageProps
  extends Omit<
    BaseNextImageProps,
    'fill' | 'preventStretch' | 'imagePositionRelative'
  > {
  width: number;
  height: number;
}

const FixedNextImage = ({
  src,
  alt,
  height,
  width,
  crop,
  smartCrop,
  skipUrlProcessing = false,
  loading = 'lazy',
  sizes = '100vw',
  ...rest
}: FixedNextImageProps) => {
  return (
    <BaseNextImage
      src={src}
      alt={alt}
      height={height}
      width={width}
      crop={crop}
      smartCrop={smartCrop}
      skipUrlProcessing={skipUrlProcessing}
      loading={loading}
      sizes={sizes}
      {...rest}
    />
  );
};

export default FixedNextImage;
